import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { RegistrationForm } from './RegistrationForm';
export function HeroSection() {
  return <section className="relative w-full lg:min-h-[90vh] flex items-center justify-center overflow-hidden bg-brand-dark pt-5 pb-10 lg:pt-28 lg:pb-16" data-id="element-74">
      {/* Foto de empresarios/inversionistas de fondo (reemplazable por tu imagen) */}
      <div className="absolute inset-0" data-id="element-75">
        <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=2000&q=80" alt="Empresarios e inversionistas reunidos" className="w-full h-full object-cover opacity-25" data-id="element-76" />
        {/* Capas de oscurecimiento para mantener el contraste del texto */}
        <div className="absolute inset-0 bg-brand-dark/70" data-id="element-77"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/60 to-brand-dark/90" data-id="element-78"></div>
      </div>
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f1f1f_1px,transparent_1px),linear-gradient(to_bottom,#1f1f1f_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-40" data-id="element-79"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-pink opacity-20 blur-[120px] rounded-full pointer-events-none" data-id="element-80"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 w-full flex flex-col lg:grid lg:grid-cols-2 lg:gap-x-12 lg:items-start" data-id="element-81">
        {/* Columna izquierda: titular + párrafo + datos, agrupados y alineados arriba.
            En mobile se "disuelve" (contents) para intercalar el formulario por order. */}
        <div className="contents lg:block lg:col-start-1 lg:row-start-1 lg:self-start" data-id="element-82">
          {/* Bloque encabezado (badge + headline) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="order-1 text-center lg:text-left" data-id="element-83">
            <span className="inline-block px-4 py-1.5 rounded-full border border-brand-pink/50 bg-brand-pink/10 text-brand-pink font-semibold text-xs md:text-sm mb-4 md:mb-6 tracking-wider uppercase" data-id="element-84">
              Cumbre de Inversión Inmobiliaria 2026
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight text-white mb-4 md:mb-6 leading-[1.1]" data-id="element-85">
              Donde el Capital Encuentra{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-pink to-purple-500" data-id="element-86">
                Tierra Fértil
              </span>
            </h1>
          </motion.div>

          {/* Bloque detalles (sub-headline + datos clave) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} className="order-3 mt-8 lg:mt-0 text-center lg:text-left" data-id="element-87">
            <p className="text-base md:text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-88">
              Descubre las Oportunidades Inmobiliarias que el Nearshoring traerá
              a San Juan del Río en 2026. Un evento exclusivo para empresarios e
              inversionistas que buscan adelantarse al próximo gran ciclo de
              plusvalía en el Bajío.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 bg-brand-gray/50 backdrop-blur-md border border-white/10 rounded-2xl p-6" data-id="element-89">
              <div className="flex flex-col items-center lg:items-start justify-center gap-2" data-id="element-90">
                <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-91">
                  <Calendar className="w-5 h-5" data-id="element-92" />
                </div>
                <div className="text-center lg:text-left" data-id="element-93">
                  <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-94">
                    Fecha
                  </p>
                  <p className="font-semibold text-white text-sm mt-0.5" data-id="element-95">
                    21 de Julio, 2026
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center lg:items-start justify-center gap-2 border-t sm:border-t-0 sm:border-l border-white/10 pt-4 sm:pt-0 sm:pl-4" data-id="element-96">
                <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-97">
                  <Clock className="w-5 h-5" data-id="element-98" />
                </div>
                <div className="text-center lg:text-left" data-id="element-99">
                  <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-100">
                    Horario
                  </p>
                  <p className="font-semibold text-white text-sm mt-0.5" data-id="element-101">
                    9:00 AM - 2:00 PM
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center lg:items-start justify-center gap-2 border-t sm:border-t-0 sm:border-l border-white/10 pt-4 sm:pt-0 sm:pl-4" data-id="element-102">
                <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-103">
                  <MapPin className="w-5 h-5" data-id="element-104" />
                </div>
                <div className="text-center lg:text-left" data-id="element-105">
                  <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-106">
                    Sede
                  </p>
                  <p className="font-semibold text-white text-sm mt-0.5" data-id="element-107">
                    San Juan del Río, Qro
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-108">
                    (Ubicación exacta al confirmar)
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bloque formulario — columna derecha en desktop, intercalado en mobile */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="order-2 w-full lg:col-start-2 lg:row-start-1 lg:self-start" data-id="element-109">
          <div className="bg-brand-gray/90 backdrop-blur-md border border-white/10 rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl" data-id="element-110">
            <div className="text-center mb-4 md:mb-6" data-id="element-111">
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-white" data-id="element-112">
                Asegura tu lugar gratis
              </h2>
              <p className="text-brand-pink font-medium text-sm mt-1" data-id="element-113">
                Válido antes del 21 de julio
              </p>
            </div>
            <RegistrationForm idPrefix="hero" data-id="element-114" />
          </div>
        </motion.div>
      </div>
    </section>;
}